import React, { useState } from "react";

interface TablePickerPopoverProps {
  onInsert: (rows: number, columns: number) => void;
}

const MAX_ROWS = 4;
const MAX_COLUMNS = 6;

const TablePickerPopover: React.FC<TablePickerPopoverProps> = ({
  onInsert,
}) => {
  const [selectedRows, setSelectedRows] = useState(3);
  const [selectedColumns, setSelectedColumns] = useState(4);

  return (
    <div className="table-picker-popover">
      <h4>Insert table</h4>
      <div className="table-picker-grid">
        {Array.from({ length: MAX_ROWS }).map((_, rowIndex) =>
          Array.from({ length: MAX_COLUMNS }).map((__, columnIndex) => {
            const row = rowIndex + 1;
            const column = columnIndex + 1;
            const isSelected = row <= selectedRows && column <= selectedColumns;

            return (
              <button
                aria-label={`${row} by ${column} table`}
                className={`table-picker-cell ${isSelected ? "selected" : ""}`}
                key={`${row}-${column}`}
                onMouseEnter={() => {
                  setSelectedRows(row);
                  setSelectedColumns(column);
                }}
                onFocus={() => {
                  setSelectedRows(row);
                  setSelectedColumns(column);
                }}
                onClick={() => onInsert(row, column)}
                type="button"
              />
            );
          }),
        )}
      </div>
      <button
        className="table-picker-insert"
        onClick={() => onInsert(selectedRows, selectedColumns)}
        type="button"
      >
        Insert table
      </button>
    </div>
  );
};

export default TablePickerPopover;
